<template>
  <div id="system-manage-email-email-address">
    <div class="ipub-tab-list">
      <a :class="['ipub-p1','ipub-cursor-pointer','ipub-tab-list--tab',titleStatu===item.scope?'active':'']"
         v-for="(item,index) in titleTab"
         style="width:230px"
         :key="item.title+index"
         @click="changeStatus(item)">{{item.title}}</a>
    </div>
    <div class="page-content">
      <ipub-table :columns="columns"
                  :pagination="false"
                  :dataSource="dataSource">
        <template v-slot:journal="{ record }">
          <font v-if="record.journal && record.journal.name"> {{record.journal && record.journal.name}}</font>
          <font v-else> -- </font>
        </template>
        <template v-slot:actions="{ record }">
          <ipub-tooltip v-show="user.codeList&&user.codeList.includes('SYSTEM.MAIL.EMAIL_ADDRESS.EDIT')">
            <div slot="title">Edit</div>
            <ipub-icon type="iconEdit"
                       @click="edit(record)" />
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <Add :isVisable="show"
         :inputData="inputData"
         @cancel="cancel"
         @confirm="confirm" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
